/**
 * @file 该文件定义了一些框架内部用的到工具函数。
 */

import {
  isDef,
  isFunction,
} from '../utils/validator'

/**
 * 在cform和csearch中使用，通过传递以_开头的函数来绑定事件。
 *
 * @ignore
 * @param {string} key
 * @param {function} value
 * @returns {boolean}
 */
export function isEvent (key, value) {
  return key.startsWith('_') && isFunction(value)
}

/**
 * 处理路由组件时，判断是否是系统菜单。
 *
 * @ignore
 * @param {string} menuType
 * @returns {boolean}
 */
export function isSystemMenu (menuType) {
  return menuType === 'system'
}

/**
 * 处理路由组件时，判断是否是应用菜单。
 *
 * @ignore
 * @param {string} menuType
 * @returns {boolean}
 */
export function isAppMenu (menuType) {
  return menuType === 'app'
}

/**
 * 判断是菜单路由
 *
 * @ignore
 * @param {string} routePath='' - 路由路径
 * @returns {boolean}
 */
export function isMenuRoute (routePath = '') {
  return routePath.match(/^\/menu/)
}

/**
 * 判断是app路由
 *
 * @ignore
 * @param {string} routePath='' - 路由路径
 * @returns {boolean}
 */
export function isAppRoute (routePath = '') {
  return routePath.match(/^\/app/)
}

/**
 * 判断是否是不带权限接口
 *
 * @ignore
 * @param {string} routePath='' - 路由路径
 * @returns {boolean}
 */
export function isNoPermissionApi (params = {}) {
  params.permission = isDef(params.permission) ? params.permission : true

  return !params.permission
}

/**
 * 判断是否是仅仅只能app方式访问的页面
 *
 * @ignore
 * @param {object} routeInfo='{}' - 路由信息
 * @returns {boolean}
 */
export function isThePageThatOnlyAccessByAppWay (routeInfo = {}) {
  return routeInfo.serviceTypeWid === 2
}

/**
 * 判断是否是仅仅只能菜单方式访问的页面
 *
 * @ignore
 * @param {object} routeInfo='{}' - 路由信息
 * @returns {boolean}
 */
export function isThePageThatOnlyAccessByMenu (routeInfo = {}) {
  return routeInfo.serviceTypeWid === 1
}
